import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);


export default new Vuex.Store({
    state:{
        routes:[],
        is:false,
        menuDataNow:[],
        minPageHeight:'',

    },

    getters:{
        getMenuDataNow(){
            return state.is
        },
        getMinPageHeight(){
            return state.minPageHeight
        }
    },

    mutations:{
        initRoutes(state,data){
            state.routes = data
        },
        CHANGESTORE(stata,bool){
            stata.is = bool
        },
        setMinPageHeight(stata,data){
            stata.minPageHeight = data
        },
    },
})

export function initMenuData(data){
    this.menuData.menuDataNow = null;
    this.menuData.menuDataNow = data;
}

export function getMenuData(){
    return this.menuData.menuDataNow
}